export const DEFAULT_MAP_TILES_VERSION = 'static';

export const MAP_TILES_LAYER_OPTIONS = {
  minZoom: 15,
  maxZoom: 18,
  tileSize: 256,
  attribution: '© Disneyland Paris',
  errorTileUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=='
};

export const getMapTilesApiUrl = () => process.env.REACT_APP_API_URL || '';

export const buildMapTilesUrlTemplate = (
  version = DEFAULT_MAP_TILES_VERSION,
  apiUrl = getMapTilesApiUrl()
) => {
  const safeVersion = version || DEFAULT_MAP_TILES_VERSION;
  return `${apiUrl}/map-tiles/{z}/{x}/{y}.jpg?v=${encodeURIComponent(safeVersion)}`;
};

export const fetchMapTilesVersion = async (apiUrl = getMapTilesApiUrl()) => {
  try {
    const response = await fetch(`${apiUrl}/map-tiles/download-stats.json?ts=${Date.now()}`, {
      cache: 'no-store'
    });

    if (!response.ok) {
      return DEFAULT_MAP_TILES_VERSION;
    }

    const stats = await response.json();
    return stats?.timestamp || DEFAULT_MAP_TILES_VERSION;
  } catch {
    return DEFAULT_MAP_TILES_VERSION;
  }
};
